/**
 * Preferred chat languages (mirrors src/utils/languages.js, plan 1 §6.9.1).
 * Used on sign-up before auth and in Settings → Workspace.
 */

export const LANGUAGES = Object.freeze([
  Object.freeze({ code: 'en', label: 'English', nativeLabel: 'English', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'ur', label: 'Urdu', nativeLabel: 'اردو', script: 'Arab', rtl: true }),
  Object.freeze({ code: 'ur-Latn', label: 'Roman Urdu', nativeLabel: 'Roman Urdu', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'ar', label: 'Arabic', nativeLabel: 'العربية', script: 'Arab', rtl: true }),
  Object.freeze({ code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी', script: 'Deva', rtl: false }),
  Object.freeze({ code: 'es', label: 'Spanish', nativeLabel: 'Español', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'fr', label: 'French', nativeLabel: 'Français', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'de', label: 'German', nativeLabel: 'Deutsch', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'tr', label: 'Turkish', nativeLabel: 'Türkçe', script: 'Latn', rtl: false }),
  Object.freeze({ code: 'id', label: 'Indonesian', nativeLabel: 'Bahasa Indonesia', script: 'Latn', rtl: false }),
]);

/** @param {{ nativeLabel: string, label: string }} lang */
export function languageOptionLabel(lang) {
  if (!lang) return 'English';
  if (lang.nativeLabel === lang.label) return lang.label;
  return `${lang.nativeLabel} (${lang.label})`;
}

/** @param {string} [selected] */
export function languageSelectOptions(selected) {
  const current = selected || 'en';
  return LANGUAGES.map((lang) => ({
    value: lang.code,
    label: languageOptionLabel(lang),
    selected: lang.code === current,
  }));
}
